var _path, _path2, _path3, _g, _path4, _g2, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFemaleScissors(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 154,
    height: 374,
    fill: "none",
    viewBox: "0 0 154 374",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F2BCA7",
    fillRule: "evenodd",
    d: "M125.299 203.571L124.817 202.986C119.27 197.259 110.155 197.13 104.46 202.699C98.7643 208.267 98.648 217.423 104.193 223.149L118.326 237.736L110.806 258.752C108.116 266.264 112.003 274.552 119.486 277.26C126.969 279.968 135.214 276.074 137.902 268.56C144.965 246.164 140.218 221.686 125.299 203.571Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCD9C3",
    fillRule: "evenodd",
    d: "M80.9255 181.155C54.3096 183.157 34.3686 206.455 36.388 233.197L37.151 247.327C39.1735 274.07 62.3833 294.122 89.0023 292.118C115.618 290.116 135.558 266.818 133.539 240.075L132.774 225.948C130.754 199.203 107.54 179.151 80.9255 181.155Z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_10643",
    width: 115,
    height: 339,
    x: 7,
    y: -110,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M121.653 219.965L41.9013 228.347L7.31036 -100.764L87.0619 -109.146L121.653 219.965Z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_10643)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FCD9C3",
    fillRule: "evenodd",
    d: "M103.733 192.762L90.0855 -80.378C88.4157 -96.2649 59.3465 -106.233 43.5323 -104.571C27.7182 -102.909 8.66423 -87.8827 10.334 -71.9958L46.4663 198.781C48.1363 214.67 62.3091 226.202 78.1233 224.54C93.9374 222.878 105.403 208.651 103.733 192.762Z",
    clipRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_0_10643",
    width: 122,
    height: 360,
    x: 13,
    y: -111,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M134.495 239.974L50.0365 248.851L13.2251 -101.386L97.6832 -110.263L134.495 239.974Z",
    clipRule: "evenodd"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_0_10643)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F2BCA7",
    fillRule: "evenodd",
    d: "M99.8786 189.762C95.8286 188.02 93.6845 183.482 93.4712 179.063L80.3775 -70.6845C78.7076 -86.5717 42.0497 -95.7398 26.2356 -94.0777C21.9016 -93.6222 17.9135 -92.1984 14.4134 -90.0798C18.9264 -97.4917 34.263 -103.597 43.5321 -104.571C59.3462 -106.233 88.4155 -96.265 90.0853 -80.3781L102.645 179.782C102.785 182.665 104.45 185.241 106.994 186.584C121.257 194.112 134.681 208.105 133.539 240.075C133.539 240.075 134.571 204.683 99.8786 189.762Z",
    clipRule: "evenodd"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCD9C3",
    fillRule: "evenodd",
    d: "M122.649 254.074C121.255 247.935 115.177 244.081 109.058 245.46C102.932 246.844 99.0855 252.956 100.468 259.111L109.436 299.049C109.438 299.057 121.199 350.821 121.2 350.829C122.596 356.97 128.674 360.824 134.791 359.445C140.918 358.061 144.764 351.949 143.382 345.794L122.656 254.103C122.654 254.095 122.652 254.084 122.649 254.074Z",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2BCA7",
    fillRule: "evenodd",
    d: "M139.14 346.763C139.14 346.763 121.254 247.935 122.649 254.074C122.651 254.084 122.654 254.095 122.656 254.103L143.382 345.794C144.764 351.949 140.918 358.061 134.791 359.445C134.077 359.606 133.363 359.689 132.657 359.712C137.525 357.553 140.356 352.178 139.14 346.763Z",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCD9C3",
    fillRule: "evenodd",
    d: "M84.9221 294.855L84.9189 294.825L80.5683 254.434C79.8916 248.16 74.2819 243.621 68.0375 244.293C61.8031 244.965 57.294 250.581 57.9518 256.84L57.9551 256.872L62.3055 297.26C62.9823 303.534 68.5922 308.075 74.8361 307.402C81.0708 306.729 85.5802 301.116 84.9221 294.855Z",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2BCA7",
    fillRule: "evenodd",
    d: "M78.2287 295.51C78.2304 295.5 78.2298 295.521 78.2287 295.51C78.2287 295.51 80.1278 272.397 80.0536 263.742L81.5733 262.993L84.9189 294.825L84.9221 294.855C85.5802 301.116 81.0726 306.746 74.8361 307.402C71.6866 307.733 70.9482 307.01 70.2542 306.955C75.418 305.429 77.3276 301.166 78.2287 295.51Z",
    clipRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCD9C3",
    fillRule: "evenodd",
    d: "M102.791 263.134C102.61 256.841 97.3931 251.874 91.1235 252.032C84.8452 252.193 79.8886 257.436 80.0533 263.742L81.1246 304.662C81.1247 304.671 82.647 357.734 82.6471 357.742C82.8276 364.037 88.0449 369.004 94.3138 368.846C100.593 368.686 105.549 363.442 105.384 357.136L102.792 263.164C102.792 263.155 102.791 263.145 102.791 263.134Z",
    clipRule: "evenodd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCD9C3",
    fillRule: "evenodd",
    d: "M64.6953 291.005L64.6921 290.975L60.3417 250.587C59.665 244.313 54.0551 239.771 47.8109 240.445C41.5765 241.118 37.0672 246.731 37.7252 252.992L37.7283 253.022L42.0789 293.412C42.7557 299.686 48.3654 304.225 54.6096 303.554C60.8442 302.882 65.3534 297.266 64.6953 291.005Z",
    clipRule: "evenodd"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2BCA7",
    fillRule: "evenodd",
    d: "M60.5738 291.438L60.5707 291.408C60.5707 291.408 60.8521 255.607 61.5286 261.882L64.6921 290.975L64.6953 291.005C65.3534 297.266 60.844 302.882 54.6096 303.554C53.8928 303.631 53.1862 303.632 52.4917 303.576C57.6557 302.05 61.1589 297.004 60.5738 291.438Z",
    clipRule: "evenodd"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2BCA7",
    fillRule: "evenodd",
    d: "M101.035 357.258C101.035 357.258 103.495 288.665 103.496 288.674L105.384 357.137C105.549 363.443 100.593 368.686 94.3137 368.846C93.5822 368.865 92.8655 368.807 92.1687 368.691C97.3623 367.525 101.18 362.806 101.035 357.258Z",
    clipRule: "evenodd"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#CE4EAA",
    fillRule: "evenodd",
    d: "M127.74 358.794L124.547 346.285C124.19 344.915 124.228 343.472 124.657 342.124C125.943 338.084 130.247 336.035 134.07 337.323C134.772 337.559 135.422 337.927 136.022 338.363C137.84 339.684 139.104 341.635 139.57 343.839L142.088 354.21L141.67 354.99C138.97 360.03 132.616 361.765 127.74 358.794Z",
    clipRule: "evenodd"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#CE4EAA",
    fillRule: "evenodd",
    d: "M87.3099 366.361L86.9315 353.455C86.8832 352.04 87.2365 350.641 87.9503 349.421C90.0894 345.765 94.7376 344.717 98.1853 346.817C98.8181 347.203 99.3727 347.706 99.8627 348.263C101.347 349.953 102.154 352.136 102.126 354.388L102.313 365.059L101.734 365.727C97.9968 370.046 91.4167 370.335 87.3099 366.361Z",
    clipRule: "evenodd"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFB600",
    strokeWidth: 1.701,
    d: "M101.157 169.702C129.159 151.534 17.9438 176.627 32.3125 191.964C34.4487 194.244 43.5329 193.012 46.7088 191.89"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFB600",
    strokeWidth: 1.701,
    d: "M41.7997 174.849C6.92039 179.194 109.819 126.434 110.59 147.267C110.705 150.364 102.919 155.289 99.6741 156.49"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFemaleScissors);
export default __webpack_public_path__ + "static/media/female_scissors.e2087bcf7e4647e92b2b7d78e6dd4b61.svg";
export { ForwardRef as ReactComponent };